import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ListCategoryCustomer } from "../types";

export function PdfCategoryCustomer(props: {
  dataList: ListCategoryCustomer[];
}) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "CATEGORY CUSTOMER", key: "category_customer", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.category_customer_code ?? "-",
    category_customer: item.category_customer_name ?? "-",
    description: item.description ?? "-",
  }));

  return (
    <PdfTemplate data={dataMap} column={columns} title="Category Customer" />
  );
}
